import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Divider from '@mui/material/Divider';
import { CircularProgress } from '@mui/material';

const PdfSummary = ({ loading, stats }) => {
  const totals = stats?.totals || {};

  return (
    <div className="UserSummary">
      <div className="summaryContainer">
        <div className="summary">
          <div className="number">{loading ? <CircularProgress size={30} /> : totals.totalExports || 0}</div>
          <div className="text">Total PDF Exports</div>
        </div>
        <div className="icon">
          <PictureAsPdfIcon color="primary" fontSize="large" />
        </div>
      </div>
      <Divider />
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">All Time Total:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totals.totalExports || 0}</div>
        </div>
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">All Time Success:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totals.totalSuccess || 0}</div>
        </div>
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">All Time Failed:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totals.totalFailed || 0}</div>
        </div>
      </div>
      <Divider sx={{ my: 1 }} />
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Last 7 Days Total:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totals.last7DaysTotal || 0}</div>
        </div>
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Last 7 Days Success:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totals.last7DaysSuccess || 0}</div>
        </div>
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Last 7 Days Failed:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totals.last7DaysFailed || 0}</div>
        </div>
      </div>
      <Divider sx={{ my: 1 }} />
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Last 30 Days Total:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totals.last30DaysTotal || 0}</div>
        </div>
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Last 30 Days Success:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totals.last30DaysSuccess || 0}</div>
        </div>
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Last 30 Days Failed:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totals.last30DaysFailed || 0}</div>
        </div>
      </div>
    </div>
  );
};

export default PdfSummary;
